import React from "react";

const InputEdit = ({
    autoFocus = false,
    validationPassed = false,
    showInputValidation = false,
    type = "text",
    name = "",
    label = null,
    inputIcon = null,
    iconPosition = "right", // ["left", "right"]
    placeholder = "",
    errorMessage = null,
    outsideLabel = "",
    inputClass = "",
    labelClass = "input-label",
    outsideLabelClass = "",
    noLabelPaddingY = "0.5rem",
    paddingTop = null,
    errorMessagePosition = "bottom",
    showPasswordStrength = false,
    showCounter = false,
    disabledInput = false,
    masked = false,
    visible = true,
    showInfo = false,
    forEmailVerification = false,
    verified = false,
    extra = { show: false, label: "" },
    optional = false,
    onChangeVisible = () => {},
    otherLabel = "",
    disableUpDownArrow = false,
    ...props // make sure this pops here is for input only
})=> 
    {
        return (
            <div className="relative w-full h-full bg-white rounded-md pl-2 pr-2 pt-1 3md:pt-3 border border-gray mt-[1px] 3md:mt-0 2sm:mt-0 2sm:pt-3">
                <div onClick={() => {}}>
                    <label className="block font-semibold text-gray-400 text-2xs 3md:text-xs">
                        {outsideLabel}
                    </label>
                    <div className="cursor-text w-full relative">
                        <input 
                            type={type}
                            name={name}
                            id={name}
                            placeholder={placeholder}
                            {...props}
                            style={{ all: 'unset', width:"100%" }}
                            className="w-full"
                        />
                    </div>
                </div>
            </div>

        )
    }
    

export default InputEdit